import LanguageCreateForm from "./language-create-form";

export default LanguageCreateForm;